//
//
//
//
//
//
//
//
//

import AuthLayout from './layouts/AuthLayout'
import MainLayout from './layouts/MainLayout'
import RightDrawer from '@/components/RightDrawer'
import { mapGetters, mapActions } from 'vuex'
import firebase from 'firebase/app'
import moment from 'moment'
import switchTheme from '@/styles/themes/themes'

export default {
	data: () => ({
		theme: '',
	}),

	async created() {
		const { theme } = JSON.parse(localStorage.getItem('theme')) || {}
		this.theme = theme
		if (!this.theme) {
			const time = moment().hours()
			this.theme = time > 5 && time < 17 ? 'light' : 'dark'
		}
		this.setTheme({ theme: this.theme })
		await this.fetchMarketsFavs()
		await this.fetchWalletsFavs()
	},
	methods: {
		...mapActions([
			'setTheme',
			'setInfo',
			'fetchUserInfo',
			'fetchWalletsFavs',
			'fetchMarketsFavs',
		]),
	},

	computed: {
		layout() {
			return (this.$route.meta.layout || 'auth' || 'main') + '-layout'
		},
	},
	components: {
		RightDrawer,
		MainLayout,
		AuthLayout,
	},
}
